import { computed } from 'mobx';
import { getStore } from '../store/Store';
import { isReadingPanePositionRight } from './readingPanePosition';
import {
    LV_RPRIGHT_RECEIVED_ADJUSTMENT,
    LV_RPFULL_RECEIVED_ADJUSTMENT,
    RPRIGHT_RECEIVED_COLUMN_CONTENT_MIN_WIDTH,
    RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH,
} from '../mailLayoutConstants';

/**
 * Cached computed value
 */
const computedIsReceivedColumnWide = computed(() => {
    const store = getStore();
    // Store value is based on column header width
    const receivedColumnWidth = store.receivedColumnWidth;

    if (!receivedColumnWidth) {
        return false;
    }

    const isReadingPaneRight = isReadingPanePositionRight();

    const receivedColumnWidthAdjusted =
        receivedColumnWidth -
        (isReadingPaneRight ? LV_RPRIGHT_RECEIVED_ADJUSTMENT : LV_RPFULL_RECEIVED_ADJUSTMENT);
    // threshold is content width plus 20px
    const threshold =
        (isReadingPaneRight
            ? RPRIGHT_RECEIVED_COLUMN_CONTENT_MIN_WIDTH
            : RPFULL_RECEIVED_COLUMN_CONTENT_MIN_WIDTH) + 20;
    return receivedColumnWidthAdjusted >= threshold;
});

/**
 * Determines if the received column is wide enough to display full date and time formatting.
 * This function returns the computed value which is automatically cached and only recalculates
 * when receivedColumnWidth or reading pane position changes.
 */
export function isReceivedColumnWide(): boolean {
    return computedIsReceivedColumnWide.get();
}
